/* zahm-set.js — Upload to assets/zahm-set.js */

(function () {
  'use strict';

  /* ── IMAGE GALLERY ── */
  var images = [];
  var currentIndex = 0;

  // Init after DOM ready — thumbs are after main image in DOM
  function zsInitThumbs() {
    images = Array.from(document.querySelectorAll('.zs-thumb'));
  }
  zsInitThumbs();

  window.zsThumb = function (btn) {
    var src = btn.dataset.src;
    currentIndex = parseInt(btn.dataset.index, 10);
    document.getElementById('zs-main-img').src = src;
    images.forEach(function (t) { t.classList.remove('zs-thumb--active'); });
    btn.classList.add('zs-thumb--active');
  };

  window.zsNav = function (dir) {
    currentIndex = (currentIndex + dir + images.length) % images.length;
    if (images[currentIndex]) zsThumb(images[currentIndex]);
  };

  /* ── COLOR SWATCHES ── */
  window.zsSwatch = function (btn) {
    document.querySelectorAll('.zs-swatch').forEach(function (s) {
      s.classList.remove('zs-swatch--active');
    });
    btn.classList.add('zs-swatch--active');

    var label = document.getElementById('zs-color-name');
    if (label) label.textContent = btn.dataset.value;

    // Swap main image
    if (btn.dataset.img) {
      var mainImg = document.getElementById('zs-main-img');
      if (mainImg) mainImg.src = btn.dataset.img;
    }

    // Update price
    if (btn.dataset.price) {
      var priceEl = document.getElementById('zs-price');
      var stickyPrice = document.getElementById('zs-sticky-price');
      if (priceEl) priceEl.textContent = btn.dataset.price;
      if (stickyPrice) stickyPrice.textContent = btn.dataset.price;
    }

    // Update compare price
    var compareEl = document.getElementById('zs-compare');
    if (compareEl) {
      compareEl.textContent = btn.dataset.compare || '';
      compareEl.style.display = btn.dataset.compare ? 'inline' : 'none';
    }

    // Update variant ID
    if (btn.dataset.variantId) {
      var variantInput = document.getElementById('zs-variant-id');
      if (variantInput) variantInput.value = btn.dataset.variantId;
    }
  };

  /* ── SIZE ── */
  window.zsSize = function (btn) {
    document.querySelectorAll('.zs-size').forEach(function (s) {
      s.classList.remove('zs-size--active');
    });
    btn.classList.add('zs-size--active');
    var label = document.getElementById('zs-size-name');
    if (label) label.textContent = btn.dataset.size;
  };

  /* ── QUANTITY ── */
  window.zsQty = function (dir) {
    var input = document.getElementById('zs-qty');
    if (!input) return;
    var val = parseInt(input.value, 10) + dir;
    if (val < 1) val = 1;
    if (val > 99) val = 99;
    input.value = val;
  };

  /* ── WISHLIST ── */
  window.zsWishlist = function (btn) {
    var heart = document.getElementById('zs-heart');
    if (!heart) return;
    btn.classList.toggle('zs-wishlisted');
    heart.classList.toggle('zs-active');
    heart.textContent = heart.classList.contains('zs-active') ? '♥' : '♡';
  };

  /* ── CART FORM FEEDBACK ── */
  var form = document.getElementById('zs-form');
  if (form) {
    form.addEventListener('submit', function () {
      var btnText = document.getElementById('zs-btn-text');
      if (btnText) {
        btnText.textContent = 'Adding…';
        setTimeout(function () { btnText.textContent = 'Add to Bag'; }, 2000);
      }
    });
  }

  /* ── STICKY BAR SCROLL TRIGGER ── */
  var sticky = document.getElementById('zs-sticky');
  if (sticky && window.innerWidth <= 768) {
    window.addEventListener('scroll', function () {
      var threshold = document.querySelector('.zs-cta-group');
      if (!threshold) return;
      var rect = threshold.getBoundingClientRect();
      sticky.style.display = rect.bottom < 0 ? 'flex' : 'none';
    }, { passive: true });
    sticky.style.display = 'none';
  }

})();

  /* ── VIDEO MODAL ── */
  window.zsShowVideo = function () {
    var modal = document.getElementById('zs-video-modal');
    var vid   = document.getElementById('zs-modal-video');
    // Get video src from first video in section
    var sectionVid = document.querySelector('.zs-video');
    if (sectionVid && sectionVid.src) {
      vid.src = sectionVid.src;
      if (sectionVid.poster) vid.poster = sectionVid.poster;
    }
    if (modal) { modal.classList.add('open'); vid.play(); }
  };

  window.zsCloseVideo = function () {
    var modal = document.getElementById('zs-video-modal');
    var vid   = document.getElementById('zs-modal-video');
    if (modal) { modal.classList.remove('open'); vid.pause(); vid.src = ''; }
  };

  /* ── SHIPPING CALCULATOR ── */

  /* ── SHIPPING POLICY ──
     $9.99 worldwide · 5-9 business days + 1-2 processing
     Free over $150
  ── */

  window.zsToggleShipping = function () {
    var body = document.getElementById('zs-ship-body');
    var icon = document.getElementById('zs-ship-icon');
    if (!body) return;
    body.classList.toggle('open');
    if (icon) icon.classList.toggle('open');
    if (body.classList.contains('open')) zsCalcShipping();
  };

  window.zsCalcShipping = function () {
    var sel = document.getElementById('zs-ship-country');
    if (!sel) return;

    // Same flat rate for all countries
    var stdDays = [5, 9];
    var procDays = [1, 2];

    // ETA = today + max processing + shipping days
    var today   = new Date();
    var fromDay = new Date(today); fromDay.setDate(today.getDate() + procDays[0] + stdDays[0]);
    var toDay   = new Date(today); toDay.setDate(today.getDate()   + procDays[1] + stdDays[1]);
    var months  = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
    var etaStr  = months[fromDay.getMonth()] + ' ' + fromDay.getDate()
                + ' – '
                + months[toDay.getMonth()]   + ' ' + toDay.getDate();

    var etaEl = document.getElementById('zs-eta-date');
    if (etaEl) etaEl.textContent = etaStr;
  };

  // Auto-open on desktop
  if (window.innerWidth >= 900) {
    var shippingBody = document.getElementById('zs-ship-body');
    var shippingIcon = document.getElementById('zs-ship-icon');
    if (shippingBody) shippingBody.classList.add('open');
    if (shippingIcon) shippingIcon.classList.add('open');
    zsCalcShipping();
  }